import { render, staticRenderFns } from "./SizeForm.vue?vue&type=template&id=752bd993&"
import script from "./SizeForm.vue?vue&type=script&lang=js&"
export * from "./SizeForm.vue?vue&type=script&lang=js&"
import style0 from "./SizeForm.vue?vue&type=style&index=0&id=752bd993&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports